import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { ActiveObject, resolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { Token } from '../tokens/Token';
import { Tray } from './Tray';
import { trayReset } from './TrayCommands';
import { TrayWidget } from './TrayWidget';

export class TrayMechanics extends ActiveObject {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(ObjectManager) private objects!: ObjectManager;
    @resolve(ProfileModel) private me!: ProfileModel;
    @resolve(WidgetManager) private widgets!: WidgetManager;

    public start(): void {
        this.burden(
            this.objects.createTrigger('Tray.AutoSize')
                .for(Tray)
                .onCreated()
                .onChildAdded()
                .onChildRemoved()
                .onChangesTo('flow')
                .doForEach(this.performTrayAutoSize.bind(this)),
            this.objects.createTrigger('Tray.SetContentsOnModeChange')
                .for(Tray)
                .onChangesTo('mode')
                .doForEach(this.setContentsOnModeChange.bind(this)),
        );

        this.realizePermanentTrayWidget();
        this.scheduler.timeout('Tray.AddSelfToParticipantTrays', 1000, this.addSelfToParticipantTrays.bind(this));
    }

    private performTrayAutoSize(t: Tray) {
        t.setPreferredSize();
    }

    private setContentsOnModeChange(t: Tray) {
        this.dispatch(trayReset, [t.id]);
    }

    private realizePermanentTrayWidget() {

        const cont = this.widgets.createContainer({
            name: 'trayWidget',
            style: 'none',
            position: ['unmanaged']
        });

        cont.add(
            this.widgets.createInline({
                ui: TrayWidget
            })
        );

        this.widgets.add(cont);
    }

    private addSelfToParticipantTrays() {
        // Find any Trays in participant mode that don't have me
        const inMode = this.objects.findAll(Tray, x => x.mode === 'participants');
        const withoutMe = inMode.filter(x => !x.polarize(Token).some(t => t.value === `(${this.me.id})`));
        if (!!withoutMe.length) {
            this.objects.update(u => {
                u.set('history', 'skip');
                for (const tray of withoutMe) {
                    const token = u.create(Token);
                    token.background = this.me.color;
                    token.value = `(${this.me.id})`;
                    tray.add(token);
                }
            });
        }

    }
}
